import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { ArrowRight, Check, Sparkles } from "lucide-react";

export function LandingPricing() {
  const { t } = useTranslation();
  const bullets = t("landing.pricing.bullets", { returnObjects: true });

  return (
    <section
      id="pricing"
      className="relative overflow-hidden bg-zinc-50/60 py-24"
      data-testid="landing-pricing"
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 mx-auto h-64 max-w-4xl rounded-full bg-gradient-to-br from-violet-400/20 to-pink-400/10 blur-3xl" />

      <div className="relative mx-auto max-w-3xl px-6 text-center lg:px-8">
        <div className="inline-flex items-center gap-2 rounded-full border border-violet-200 bg-white px-3 py-1 text-xs font-semibold uppercase tracking-wider text-violet-700 shadow-sm">
          <Sparkles className="h-3 w-3" />
          {t("landing.pricing.eyebrow")}
        </div>
        <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-zinc-950 md:text-5xl">
          {t("landing.pricing.title")}
        </h2>
        <p className="mt-4 text-base text-zinc-600 md:text-lg">
          {t("landing.pricing.sub")}
        </p>
      </div>

      <div className="relative mx-auto mt-12 max-w-lg px-6">
        <div className="relative rounded-3xl border border-zinc-200 bg-white p-8 shadow-2xl shadow-violet-500/15 md:p-10">
          {/* Ribbon */}
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-gradient-to-r from-violet-600 to-pink-500 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-white shadow-lg shadow-pink-500/30">
            En popüler
          </div>

          <div className="flex items-baseline gap-1">
            <span className="font-display text-6xl font-extrabold tracking-tight text-zinc-950 md:text-7xl">
              {t("landing.pricing.price")}
            </span>
            <span className="text-sm text-zinc-500">{t("landing.pricing.period")}</span>
          </div>

          <ul className="mt-6 space-y-3">
            {Array.isArray(bullets) &&
              bullets.map((b, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 text-sm text-zinc-700 md:text-base"
                >
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-emerald-500 text-white">
                    <Check className="h-3 w-3" strokeWidth={3} />
                  </span>
                  <span>{b}</span>
                </li>
              ))}
          </ul>

          <Link to="/register" className="mt-8 block">
            <Button
              size="lg"
              className="w-full gap-2 bg-gradient-to-r from-[#5B4CFB] to-[#7c5cf6] text-white shadow-xl shadow-violet-500/30 hover:from-[#4f40f0] hover:to-[#6f4df0]"
              data-testid="landing-pricing-cta"
            >
              {t("landing.pricing.cta")}
              <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
